import { Injectable } from '@angular/core';

/**
 * In-memory marker for "a Cognito MFA challenge is in progress in this tab".
 * Deliberately not in the store: the auth slice is persisted to localStorage, so a store flag
 * would survive a refresh even though Amplify's challenge session (also in memory) does not.
 */
@Injectable({ providedIn: 'root' })
export class MfaChallengeService {
  private pending = false;

  start(): void {
    this.pending = true;
  }

  clear(): void {
    this.pending = false;
  }

  isPending(): boolean {
    return this.pending;
  }
}
